import { TranslationObject } from '../../i18n/translation';

const translations: TranslationObject = {
  noOptions: {
    id: 'autocomplete.noOptions',
    nb: 'Ingen mulige valg',
    en: 'No options',
  },
  loading: {
    id: 'autocomplete.loading',
    nb: 'Laster inn...',
    en: 'Loading...',
  },
  defaultPlaceholder: {
    id: 'autocomplete.defaultPlaceholder',
    nb: 'Søk...',
    en: 'Search...',
  },
};

export default translations;
